import React from "react";

const PublicationsAndPatentsView = () => {
  return <>Publications And Patents View</>;
};

export default PublicationsAndPatentsView;